import { Dictionary } from '@feedyou-ai/feedbot-schema'

export type ItemByKey<Key extends string, Item extends object> = Dictionary<
  Key,
  Item & { condition?: boolean }
>

export function filterDictionaryByConditionField<Key extends string, Item extends object>(
  dictionary: ItemByKey<Key, Item>
): ItemByKey<Key, Item> {
  return (Object.keys(dictionary) as Key[])
    .filter(key => !dictionary[key]?.hasOwnProperty('condition') || dictionary[key].condition)
    .reduce((output, key) => ({ ...output, [key]: dictionary[key] }), {})
}
